module.exports = __webpack_public_path__ + "img/edc-ovo.0e07c30d.png";